import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-down\"><path d=\"M819.02 465.01l93.99 93.98L512 960 110.99 558.99l93.99-93.98L512 772.03l307.02-307.02z m0-401.01l93.99 93.99-401 401-401.01-401L204.98 64 512 371.02 819.02 64z\" p-id=\"26657\" fill=\"#E1E6E6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol